module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card",
    class: {
      'card-plain': _vm.isPlain
    }
  }, [(_vm.data != null) ? _c('div', {
    staticClass: "card-header",
    attrs: {
      "data-background-color": "magenta-dark"
    }
  }, [_vm._t("header", function() {
    return [_c('h4', {
      staticClass: "title"
    }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', {
      staticClass: "category"
    }, [_vm._v(_vm._s(_vm.subTitle))])]
  })], 2) : _vm._e(), _vm._v(" "), (_vm.data != null && _vm.data.length > 0) ? _c('div', {
    staticClass: "card-content table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped table-hover",
    class: _vm.tableClass
  }, [_c('thead', [_c('th'), _vm._v(" "), _vm._l((_vm.columnsTitles), function(colTitle) {
    return _c('th', [_vm._v(_vm._s(colTitle))])
  })], 2), _vm._v(" "), _c('tbody', _vm._l((_vm.data), function(item) {
    return _c('tr', [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selected),
        expression: "selected"
      }],
      staticClass: "form-check-input",
      attrs: {
        "name": "radio",
        "type": "radio"
      },
      domProps: {
        "value": item,
        "checked": _vm._q(_vm.selected, item)
      },
      on: {
        "change": [function($event) {
          _vm.selected = item
        }, _vm.rowSelected]
      }
    })]), _vm._v(" "), _vm._l((_vm.columnsValues), function(attributeName) {
      return (_vm.hasValue(item, attributeName)) ? _c('td', [_vm._v(_vm._s(_vm.itemValue(item, attributeName)))]) : _vm._e()
    })], 2)
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.data != null && _vm.data.length == 0) ? _c('div', [_c('br'), _c('h4', {
    attrs: {
      "id": "no_data"
    }
  }, [_vm._v("No hay resultados para mostrar")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-de329a72!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Utils/TableWithCheckbox.vue
// module id = 262
// module chunks = 3